<template>
  <Form class="realinfo-see-verification" ref="formValidate" :model="formValidate" :rules="ruleValidate">
    <FormItem>
      <Input v-model="accountInfo.mobile" placeholder="手机号码" disabled>
        <span slot="prefix" class="proxy-icon mobile-icon"></span>
      </Input>
    </FormItem>
    <FormItem prop="imgCode" class="imgCode-form">
      <Input v-model="formValidate.imgCode" placeholder="图形验证码" style="width: 340px;">
        <span slot="prefix" class="proxy-icon imgCode-icon"></span>
      </Input>
      <graphicalVerificationCode ref="graphical" />
    </FormItem>
    <FormItem prop="smsCode" class="smsCode-form">
      <Input v-model="formValidate.smsCode" placeholder="手机验证码" style="width: 340px;">
        <span slot="prefix" class="proxy-icon smsCode-icon"></span>
      </Input>
      <mobileVerificationCode source="seeRealname" :obj="formValidate" />
    </FormItem>
    <FormItem>
      <Button type="primary" :loading="loading" @click="handleSubmit('formValidate')">确定</Button>
    </FormItem>
  </Form>
</template>

<script>
import graphicalVerificationCode from "@/components/verificationCode/graphical"
import mobileVerificationCode from "@/components/verificationCode/mobile"
export default {
  name: "RealinfoSeeVerification",
  components: {
    graphicalVerificationCode,
    mobileVerificationCode
  },
  data() {
    return {
      loading: false,
      teacherList: [],
      formValidate: {
        imgCode: '',
        smsCode: ''
      },
      ruleValidate: {
        imgCode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    accountInfo() {
      return this.$store.getters["account/accountInfo"]
    },
    guid() {
      return this.$store.getters["globe/guid"]
    }
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.CheckSmsCodeByChangeBankNo()
        } else {
          // this.$Message.error('验证失败!')
        }
      })
    },
    CheckSmsCodeByChangeBankNo() {
      this.$store.dispatch('account/CheckSmsCodeByChangeBankNo', { smsCode: this.formValidate.smsCode }).then(() => {
        this.loading = false
        this.$emit("changeverificationoStatus")
      }).catch(({ msg })  => {
        this.loading = false
        this.$Message.error(msg)
        this.$refs["graphical"].getGraphicalCode()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.imgCode-form{
  /deep/.ivu-form-item-content{
    display: flex;
    align-items: center;
  }
}
.smsCode-form{
  /deep/.ivu-form-item-content{
    display: flex;
    align-items: center;
  }
}
</style>